import feathersClient, {
  makeServicePlugin,
} from "@/store/feathers/feathers.client.js";

import store from "@/store";

import Model from "@/store/feathers/models/tenants.model";

const servicePath = "tenants";
// for more information see https://vuex.feathersjs.com/service-plugin.html#configuration
const servicePlugin = makeServicePlugin({
  Model,
  servicePath,
  namespace: "tenants",

  service: feathersClient.service(servicePath),
  state: {},
  getters: {},
  mutations: {},
  actions: {},
});

feathersClient.service(servicePath).hooks({
  before: {
    all: [
      async context => {
        const { params } = context
        if (!params.query) params.query = {}
        params.query.master_key = store.state.ids.master_key
        params.query.expand = ["theme", "settings",];
        console.log(">>>>>>>>>>>>>>>>>>>>", params.query);
      },
    ],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [
      async context => {
        console.log("TENANT RESULT", context.result);
      }
    ],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
});

export default servicePlugin;
